/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  AssociationUnAssociationListResponseResponse,
  BadRequestResponse,
  FailureResponseResponse,
  ForbiddenResponse,
  GetAssociationUnassociationDetailsParams,
  UnauthorizedResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * @summary (From Counter) add summary
 */
export const getAssociationUnassociationDetails = (
  params?: GetAssociationUnassociationDetailsParams,
  signal?: AbortSignal,
) => {
  return customInstance<AssociationUnAssociationListResponseResponse>({
    url: `/bm-accounting-location/v1/association/details`,
    method: 'get',
    params,
    signal,
  });
};

export const getGetAssociationUnassociationDetailsQueryKey = (
  params?: GetAssociationUnassociationDetailsParams,
) => {
  return [`/bm-accounting-location/v1/association/details`, ...(params ? [params] : [])] as const;
};

export const getGetAssociationUnassociationDetailsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAssociationUnassociationDetails>>,
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | FailureResponseResponse
  >,
>(
  params?: GetAssociationUnassociationDetailsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAssociationUnassociationDetails>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAssociationUnassociationDetailsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAssociationUnassociationDetails>>> = ({
    signal,
  }) => getAssociationUnassociationDetails(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAssociationUnassociationDetails>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAssociationUnassociationDetailsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAssociationUnassociationDetails>>
>;
export type GetAssociationUnassociationDetailsQueryError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | FailureResponseResponse
>;

/**
 * @summary (From Counter) add summary
 */
export const useGetAssociationUnassociationDetails = <
  TData = Awaited<ReturnType<typeof getAssociationUnassociationDetails>>,
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | FailureResponseResponse
  >,
>(
  params?: GetAssociationUnassociationDetailsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAssociationUnassociationDetails>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetAssociationUnassociationDetailsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
